import config from "./../config";
import core from "./../core";
import { map, groupBy, concat, find, findLast, filter } from "lodash";
const app = {};
app.isSetWebview = function () {
  let cookieWEBVIEW = window.source === config.WEBVIEW_KEY;
  if (cookieWEBVIEW) {
    config.IS_WEBVIEW = true;
  } else {
    config.IS_WEBVIEW = false;
  }

  return config.IS_WEBVIEW;
};

app.resetBracket = (arrContraintsDefault) => {
  let arrContraints = [];
  for (let i = 0; i < arrContraintsDefault.length; i++) {
    let objStage = arrContraintsDefault[i];
    const { name, subStage } = objStage.stage;
    let arrSubstage = [];
    for (let j = 0; j < (subStage || []).length; j++) {
      let objSubStage = subStage[j];
      const { team, teamSelection } = objSubStage;
      let arrTeamSelection = [];
      let arrTeam = [];
      for (let jN = 0; jN < (team || []).length; jN++) {
        let objTeam = team[jN];
        arrTeam.push({ ...objTeam });
      }
      if (name === config.enumStage.teamSelection) {
        for (let jN = 0; jN < (teamSelection || []).length; jN++) {
          let objTeam = teamSelection[jN];
          arrTeamSelection.push({ ...objTeam });
        }
      }
      let pushSbstage = { ...objSubStage, team: arrTeam };
      if (arrTeamSelection.length) {
        pushSbstage.teamSelection = arrTeamSelection;
      }
      arrSubstage.push(pushSbstage);
    }
    arrSubstage = arrSubstage.sort((a, b) => {
      let valueA = a.name;
      let valueB = b.name;

      if (valueA > valueB) {
        return 1;
      }
      if (valueA < valueB) {
        return -1;
      }
      return 0;
    });
    arrContraints.push({
      ...objStage,
      stage: { ...objStage.stage, name: name, subStage: arrSubstage },
    });
  }
  return arrContraints;
};

//======================Tracking======================

// googleAnalyticsTracking Events Page ...

// window.gtag => window.ga
app.googleAnalyticsTracking = function (sTitle, sPath) {
  // console.log("sTitle :", sTitle, "sPath :", sPath);
  let fResp = false;

  // new code dataLayer ...
  // if (window.dataLayer) {
  //   window.dataLayer.push({
  //     event: "siGamingEvent",
  //     si_gaming: {
  //       event_name: action,
  //       event_parameter: category,
  //       event_value: opt_label,
  //     },
  //   });
  // }

  // if (window.dataLayer) {
  //   window.dataLayer.push({
  //     event: "siGamingEvent",
  //     si_gaming: {
  //       event_name: action,
  //       event_parameter: action,
  //       event_value: opt_label,
  //     },
  //   });
  // }
  // if (window.lastPath !== sPath) {
  // if (window.gtag) {
  //   window.gtag("config", config.GA_TRACKING_ID, {
  //     page_title: sTitle,
  //     page_path: sPath,
  //   });
  // }
  // if ("ga" in window && ga.getAll) {
  //   let tracker = ga.getAll()[0];
  //   if (tracker) {
  //     tracker.send(data);
  //   }
  // }
  // window.lastPath = sPath;
  // fResp = true;
  // }
  return fResp;
};

// googleAnalyticsEventTracking CTA Buttons ...
app.googleAnalyticsEventTracking = function (action, category, opt_label) {
  let fResp = false;
  // console.log(
  //   "action :",
  //   action,
  //   "| category :",
  //   category,
  //   "| label :",
  //   opt_label
  // );

  // old code ...
  // if (window.gtag) {
  //   window.gtag("event", action, {
  //     event_category: category,
  //     event_label: opt_label,
  //   });
  // }

  // new code dataLayer ...
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "siGamingEvent",
      si_gaming: {
        event_name: "predictor_game", // have to keep constant
        event_parameter: category, // questionOpened
        event_value: opt_label, // prediction_gameplay
      },
    });
  }
  return fResp;
};

app.TrackGoogleAnalyticsEventByObj = function (obj) {
  if (obj) {
    app.googleAnalyticsEventTracking(obj.action, obj.category, obj.label);
  }
};

app.d11DataTracking = function (sEventName, ObjEventParam) {
  if (window.D11Data) {
    window.D11Data.track(sEventName, ObjEventParam);
  }
  //console.warn("sEventName = ", sEventName, 'ObjEventParam: ', ObjEventParam)
};

app.addUTMParameters = (ObjEventParam) => {
  /* const objUrl = core.getQueryParams((window.location.href));
  if (objUrl) {
    ObjEventParam.utm_source = objUrl.utm_source ? objUrl.utm_source : null;
    ObjEventParam.utm_campaign = objUrl.utm_campaign ? objUrl.utm_campaign : null;
    ObjEventParam.utm_content = objUrl.utm_content ? objUrl.utm_content : null;
    ObjEventParam.utm_medium = objUrl.utm_medium ? objUrl.utm_medium : null;
  } */
  return ObjEventParam;
};

app.loginRegisterCTA = () => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    sourceClick: "Login / Register",
    // browser_info:navigator.userAgent,
  };
  ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.login_register_cta,
    ObjEventParam
  );
};
app.landingLetsPlayCTA = () => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    button_name: "Let’s Play",
  };
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.landing_lets_play_cta,
    ObjEventParam
  );
};
app.landingRulesCTA = () => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
  };
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.landing_rules_page_cta,
    ObjEventParam
  );
};
app.downloadApp = (button_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    button_name: button_name,
    // browser_info:navigator.userAgent,
  };
  ObjEventParam = app.addUTMParameters(ObjEventParam);
  const cookie = app.getLoginCookie();
  if (cookie) {
    ObjEventParam.userId = cookie.SocialId ? cookie.SocialId : null;
  }
  app.d11DataTracking(config.enumTrackingEventNames.DownloadApp, ObjEventParam);
};
app.landingTNC = () => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    // browser_info:navigator.userAgent,
  };
  // ObjEventParam = app.addUTMParameters(ObjEventParam);
  const cookie = app.getLoginCookie();
  if (cookie) {
    ObjEventParam.userId = cookie.SocialId ? cookie.SocialId : null;
  }
  app.d11DataTracking(
    config.enumTrackingEventNames.landing_tnc_link,
    ObjEventParam
  );
};
app.landingPrivacyPolicy = () => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    // browser_info:navigator.userAgent,
  };
  // ObjEventParam = app.addUTMParameters(ObjEventParam);
  const cookie = app.getLoginCookie();
  if (cookie) {
    ObjEventParam.userId = cookie.SocialId ? cookie.SocialId : null;
  }
  app.d11DataTracking(
    config.enumTrackingEventNames.landing_privacy_policy_link,
    ObjEventParam
  );
};
app.matchesSeeCluesCTA = (screen_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
  };
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.matches_see_clues_cta,
    ObjEventParam
  );
};
app.matchesInformation = (screen_name, tab_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
    //tab_name: tab_name ? tab_name : null,
  };
  if (tab_name) {
    ObjEventParam.tab_name = tab_name;
  }
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.InformationClicked,
    ObjEventParam
  );
};
app.matchesLeaderboardCTA = (screen_name, tab_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
    //tab_name: tab_name ? tab_name : null,
  };
  if (tab_name) {
    ObjEventParam.tab_name = tab_name;
  }
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.leaderboard_cta_clicked,
    ObjEventParam
  );
};

app.fcLogoClicked = () => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    // browser_info:navigator.userAgent,
  };
  ObjEventParam = app.addUTMParameters(ObjEventParam);
  const cookie = app.getLoginCookie();
  if (cookie) {
    ObjEventParam.userId = cookie.SocialId ? cookie.SocialId : null;
  }
  app.d11DataTracking(
    config.enumTrackingEventNames.FClogoClicked,
    ObjEventParam
  );
};

app.backButtonClicked = (screen_name, tab_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
    //tab_name: tab_name ? tab_name : null,
  };
  if (tab_name) {
    ObjEventParam.tab_name = tab_name;
  }
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.BackButtonClicked,
    ObjEventParam
  );
};

app.createTeamClicked = (screen_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
  };
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  const cookie = app.getLoginCookie();
  if (cookie) {
    ObjEventParam.userId = cookie.SocialId ? cookie.SocialId : null;
  }
  app.d11DataTracking(
    config.enumTrackingEventNames.create_team_clicked,
    ObjEventParam
  );
};

app.bottomNavClicked = (screen_name, tab_name, selection) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
    //tab_name: tab_name ? tab_name : null,
    //selection: selection ? selection : null,
  };
  if (tab_name) {
    ObjEventParam.tab_name = tab_name;
  }
  if (selection) {
    ObjEventParam.selection = selection;
  }
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.BottomNavClicked,
    ObjEventParam
  );
};
app.watchHeighlightClicked = (screen_name, tab_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
    //tab_name: tab_name ? tab_name : null,
  };
  if (tab_name) {
    ObjEventParam.tab_name = tab_name;
  }
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  app.d11DataTracking(
    config.enumTrackingEventNames.WatchHighlightsClicked,
    ObjEventParam
  );
};
app.confirmTeam = (screen_name) => {
  let ObjEventParam = {
    feature_name: config.enumFeatureName.default,
    screen_name: screen_name ? screen_name : null,
  };
  //ObjEventParam = app.addUTMParameters(ObjEventParam);
  const cookie = app.getLoginCookie();
  if (cookie) {
    ObjEventParam.userId = cookie.SocialId ? cookie.SocialId : null;
  }
  app.d11DataTracking(config.enumTrackingEventNames.ConfirmTeam, ObjEventParam);
};
//======================Tracking======================

app.getLoginCookie = function () {
  let cookie = core.getCookie(config.COOKIE_FANTASY);
  let returnCookie = null;
  try {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let parsedCookie = JSON.parse(cookie);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }
    return returnCookie;
  } catch (error) {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let cookieSpecial = cookie.replace(
        /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g,
        ""
      );
      let parsedCookie = JSON.parse(cookieSpecial);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }

    return returnCookie;
  }
};
app.getLoginCookieStatus = () => {
  let parentCookie = core.getCookie(config.COOKIE_PARENT);
  let fantasyCookie = core.getCookie(config.COOKIE_FANTASY);
  let ret = config.enumLoginCookie.bothNotPresent;
  if (!parentCookie && !fantasyCookie) {
    ret = config.enumLoginCookie.bothNotPresent;
  } else if (parentCookie && fantasyCookie) {
    ret = config.enumLoginCookie.bothPresent;
  } else if (parentCookie && !fantasyCookie) {
    // only Fifa cookie present.
    ret = config.enumLoginCookie.parentPresent;
  } else if (!parentCookie && fantasyCookie) {
    // only Fantasy cookie present.
    ret = config.enumLoginCookie.fantasyPresent;
  }

  return ret;
};

app.eventValidators = (el, cookie) => {
  let resp = true;
  return resp;
};

app.eventValidatorsLoggedIn = (el, cookie) => {
  let resp = false;
  if (cookie) {
    resp = true;
  }
  return resp;
};

app.deleteAllCookies = (reloadPage) => {
  var cookies = document.cookie.split(";");
  let exDate = new Date();
  exDate.setDate(exDate.getDate() + -1);
  app.deleteAllLocalStorage();
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    document.cookie =
      name +
      "=;expires=" +
      exDate.toUTCString() +
      ";domain=" +
      config.sDomain +
      ";path=/";

    document.cookie = name + "=;expires=" + exDate.toUTCString() + ";path=/";
  }
  //
  //core.removeLocalStorageValue(config.enumCookie.inviteCookie);
  if (reloadPage) {
    window.location.reload();
  }
};

app.deleteAllLocalStorage = () => {
  core.removeLocalStorageValue(config.tempSelectedPlayerCookieName);
  core.removeLocalStorageValue(config.tempTeamGamedayId);
};

app.creteEmptyTeamFormation = (objFormation, trans) => {
  let arrSelectedPlayer = [];
  const jDfCount = objFormation ? objFormation.DEF : 0;
  const jMfCount = objFormation ? objFormation.MID : 0;
  const jFwCount = objFormation ? objFormation.FWD : 0;
  const jGkCount = 1;
  let arrSelectedPlayerMain = {};
  //Forward Row
  for (let j = 0; j < jFwCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.forwards ? trans.forwards : "Forwards",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.forwards,
      jorder: j + 1,
      skillNameShort: (trans && trans.fwd ? trans.fwd : "FWD").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.forwards] = arrSelectedPlayer;
  //MidFielders Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jMfCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.midfielders ? trans.midfielders : "Midfielders",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.midfielders,
      jorder: j + 1,
      skillNameShort: (trans && trans.mid ? trans.mid : "MID").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.midfielders] = arrSelectedPlayer;
  //Defenders Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jDfCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.defenders ? trans.defenders : "Defenders",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.defenders,
      jorder: j + 1,
      skillNameShort: (trans && trans.def ? trans.def : "DEF").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.defenders] = arrSelectedPlayer;
  //GoalKeepers Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jGkCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.goalkeepers ? trans.goalkeepers : "Goalkeepers",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.goalkeepers,
      jorder: j + 1,
      skillNameShort: (trans && trans.gk ? trans.gk : "GK").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.goalkeepers] = arrSelectedPlayer;
  return arrSelectedPlayerMain;
};
app.creatrNewSkillRow = (arrSkillOld, arrSkillNew, jAvoidFiltreIndex) => {
  for (let jN = 0; jN < (arrSkillOld || []).length; jN++) {
    const objRowOld = arrSkillOld[jN];
    for (let jNDex = 0; jNDex < (arrSkillNew || []).length; jNDex++) {
      const objRowNew = arrSkillNew[jNDex];
      if (
        jAvoidFiltreIndex !== objRowOld.filterIndex &&
        objRowNew.filterIndex === config.emptyValue
      ) {
        objRowNew.filterIndex = objRowOld.filterIndex;
        break;
      }
    }
  }
  return arrSkillNew;
};
app.getCurrentSelectedTabIndexes = (
  jSkillP,
  arrSkillFiltreTab,
  arrSelectedPlayer
) => {
  let jSkillFiltreTab = jSkillP;
  let jSkillFiltreTabPlayer = -1;
  loop1: for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
    const objSkill = arrSkillFiltreTab[j];
    const jSkillKey = objSkill.id;
    const arrSelectedPlayerBySkill = arrSelectedPlayer[jSkillKey];
    //
    const arrSkillNew = [];
    const arrSkillNewEmpty = [];
    for (let jN = 0; jN < (arrSelectedPlayerBySkill || []).length; jN++) {
      let objSkill = arrSelectedPlayerBySkill[jN];
      if (objSkill.filterIndex === config.emptyValue) {
        arrSkillNewEmpty.push({ ...objSkill });
      } else {
        arrSkillNew.push({ ...objSkill });
      }
    }
    for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
      let objSkill = arrSkillNewEmpty[jN];
      arrSkillNew.push({ ...objSkill });
    }
    //
    for (let jN = 0; jN < (arrSkillNew || []).length; jN++) {
      const objPlayer = arrSkillNew[jN];
      if (objPlayer.filterIndex === config.emptyValue) {
        if (
          (!jSkillFiltreTab && jSkillFiltreTab !== 0) ||
          jSkillFiltreTab <= j
        ) {
          jSkillFiltreTab = j;
          jSkillFiltreTabPlayer = jN;
          break loop1;
        }
      }
    }
  }
  if (jSkillFiltreTabPlayer === -1) {
    loop1: for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
      const objSkill = arrSkillFiltreTab[j];
      const jSkillKey = objSkill.id;
      const arrSelectedPlayerBySkill = arrSelectedPlayer[jSkillKey];
      //
      const arrSkillNew = [];
      const arrSkillNewEmpty = [];
      for (let jN = 0; jN < (arrSelectedPlayerBySkill || []).length; jN++) {
        let objSkill = arrSelectedPlayerBySkill[jN];
        if (objSkill.filterIndex === config.emptyValue) {
          arrSkillNewEmpty.push({ ...objSkill });
        } else {
          arrSkillNew.push({ ...objSkill });
        }
      }
      for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
        let objSkill = arrSkillNewEmpty[jN];
        arrSkillNew.push({ ...objSkill });
      }
      //
      for (let jN = 0; jN < (arrSkillNew || []).length; jN++) {
        const objPlayer = arrSkillNew[jN];
        if (objPlayer.filterIndex === config.emptyValue) {
          if (jSkillFiltreTab > j) {
            jSkillFiltreTab = j;
            jSkillFiltreTabPlayer = jN;
            break loop1;
          }
        }
      }
    }
  }
  if (jSkillFiltreTabPlayer === -1) {
    jSkillFiltreTab = config.emptyValue;
    jSkillFiltreTabPlayer = config.emptyValue;
  }
  return {
    jSkillFiltreTab: jSkillFiltreTab,
    jSkillFiltreTabPlayer: jSkillFiltreTabPlayer,
  };
};

app.isPlayerFromSelection = (
  arrSelectedPlayer,
  sKeyToSearch,
  sValueToSearch
) => {
  const jIndexSelectedPlayer = core.getIndexOfArrayByValue(
    arrSelectedPlayer,
    sKeyToSearch,
    sValueToSearch
  );
  const isSelected = jIndexSelectedPlayer === -1 ? false : true;
  return isSelected;
};
app.getPlayerDetailsById = (arrPlayers, jId) => {
  let objPlayer = null;
  if (jId) {
    objPlayer = arrPlayers && arrPlayers.find((ele) => ele.Id === jId);
  }
  return objPlayer;
};
app.breakRefInSelection = (arrSelectedPlayer) => {
  let arrSelectedPlayerMain = {};
  for (let jKey in arrSelectedPlayer) {
    const arrSkill = arrSelectedPlayer[jKey];
    let arrSkillNew = [];
    for (let jN = 0; jN < (arrSkill || []).length; jN++) {
      let objSkill = arrSkill[jN];
      arrSkillNew.push({ ...objSkill });
    }
    arrSelectedPlayerMain[jKey] = arrSkillNew;
  }
  return arrSelectedPlayerMain;
};
app.getFilledCountOfPlayerSelectionBySkill = (arrSelectedPlayer, jSKill) => {
  let jCount = 0;
  const arrSkill = arrSelectedPlayer[jSKill];
  for (let jNDex = 0; jNDex < (arrSkill || []).length; jNDex++) {
    const objRowNew = arrSkill[jNDex];
    if (config.emptyValue !== objRowNew.filterIndex) {
      jCount = jCount + 1;
    }
  }
  return jCount;
};
app.getGenerateImage = function (guid, scenarioCode, callback) {
  let sUrl = config.shreGenerateImage.replace("{{guid}}", guid);
  sUrl = sUrl.replace("{{gamedayid}}", 1);
  let obj = {
    url: sUrl,
    method: "post",
    params: {
      LangCode: config.CURRENT_LANGUAGE,
      phaseId: 1,
      scenario: scenarioCode,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};
app.getGenerateImageResult = function (formationId, callback) {
  let sUrl = config.shreGenerateImageResult;
  let obj = {
    url: sUrl,
    method: "get",
    params: {
      formationId: formationId,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

//
app.getSelectedFixture = (arrFixtures, jFixtures) => {
  let objFixture = null;
  if (arrFixtures && arrFixtures.length) {
    objFixture = arrFixtures[jFixtures];
  }
  return objFixture;
};
app.getSelectedPosition = (arrSkillFiltreTab, jSkillFiltreTab) => {
  let objSkillFiltreTab = null;
  if (arrSkillFiltreTab && arrSkillFiltreTab.length) {
    objSkillFiltreTab = arrSkillFiltreTab[jSkillFiltreTab];
  }
  return objSkillFiltreTab;
};

app.getFixtureStatusByRow = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.IsLocked == 0 && element.IsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  } else if (element.IsLocked == 0 && element.IsCurrent == 1) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (
    element.IsLocked == 1 &&
    element.IsCurrent == 1 &&
    element.IsLive == 0
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (
    element.IsLocked == 1 &&
    element.IsCurrent == 1 &&
    element.IsLive !== 0
  ) {
    sMatchStatus = config.enumFixtureType.isLive;
  } else if (element.IsCurrent == 2 && element.IsLocked == 1) {
    /* else if (
    (element.MhIsLocked == 1 &&
      element.IsLive == 2 &&
      element.MhIsCurrent == 1) ||
    Number(element.MatchStatus) === 3
  ) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } */
    /*else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } */
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.IsCurrent == 3 && element.IsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  }
  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};

app.getFixtureStatusByMatches = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.MhIsLocked == 0 && element.MhIsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  }
  //(if gameday is open)
  else if (
    element.IsLocked == 0 &&
    element.IsCurrent == 1 &&
    element.MhIsLocked == 0 &&
    element.MhIsCurrent == 1
  ) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (
    element.MhIsLocked == 1 &&
    element.IsLive == 0 &&
    element.MhIsCurrent == 1
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (
    (element.MhIsLocked == 1 &&
      element.IsLive == 2 &&
      element.MhIsCurrent == 1) ||
    Number(element.MatchStatus) === 3
  ) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } else if (element.MhIsCurrent == 2 && element.MhIsLocked == 1) {
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.MhIsCurrent == 3 && element.MhIsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  }
  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};

app.getGdForMatchFile = (allFixtures) => {
  let obj = {};
  for (let jFixture = 0; jFixture < allFixtures.length; jFixture++) {
    let rowFixtures = allFixtures[jFixture];
    let matchFileName = rowFixtures.MatchFile;
    let matchGD = rowFixtures.TeamGamedayId;
    if (matchFileName) {
      obj[matchFileName] = matchGD;
    }
  }
  return obj;
};

app.getGamedayIdFromMatchId = (matchId, arrFixtures) => {
  let match = arrFixtures.find((obj) => {
    return matchId === obj?.MatchId;
  });
  return match?.GamedayId;
};

app.getTourStatus = (finalMatch, ftgdid) => {
  let status = config.enumEotScenarios.no_eot;
  // if (finalMatch) {
  //   let objCookie = app.getLoginCookie();
  //   let isValidUser = (objCookie && objCookie.SocialId);
  //   let firstGD = ftgdid ? ftgdid : 0;
  //   let HasTeamForFinal = (firstGD && (firstGD <= finalMatch.TeamGamedayId));
  //   let isFinalLive = finalMatch.IsFixtureAnnounce == config.isAnnouncedStatus.tour_last_match_live;
  //   let isFinalEnded = finalMatch.IsFixtureAnnounce == config.isAnnouncedStatus.tour_ended;
  //   if (isFinalLive || isFinalEnded) {
  //     if (isValidUser) {
  //       if (HasTeamForFinal) {
  //         if (isFinalLive) {
  //           status = config.enumEotScenarios.logged_in_with_live_team;
  //         } else {
  //           status = config.enumEotScenarios.logged_in_with_team;
  //         }
  //       } else {
  //         status = config.enumEotScenarios.logged_in_without_team;
  //       }
  //     } else {
  //       status = config.enumEotScenarios.logged_out_user;
  //     }
  //   }
  // }
  return status;
};

app.generateFixtureArray = (lstFixturesP) => {
  let lstFixtures = lstFixturesP;
  //console.log(lstFixtures);
  let arrRound = [];
  for (let jFixture = 0; jFixture < lstFixtures.length; jFixture++) {
    let rowFixtures = lstFixtures[jFixture];
    // let webMonth = core.dateFormat(rowFixtures.Deadlinedate, 'mmmm');
    // let mobMonth = core.dateFormat(rowFixtures.Deadlinedate, 'mmm');
    // let webDate = core.dateFormat(rowFixtures.Deadlinedate, 'd');
    // let S = /*(dateLabel[webDate] ? dateLabel[webDate] : 'th');//*/core.dateFormat(rowFixtures.DateTime, 'S');
    // let sDate = core.dateFormat(rowFixtures.Deadlinedate, 'dd/mm/yyyy hh:MM TT');
    let jDayNo = rowFixtures.Matchday;
    let TeamGamedayId = rowFixtures.TeamGamedayId
      ? +rowFixtures.TeamGamedayId
      : 0;
    let jRound = core.getIndexOfArrayByValue(
      arrRound,
      "TeamGamedayId",
      TeamGamedayId
    );
    if (jRound === -1) {
      let arrDetails = [{ ...rowFixtures }];
      arrRound.push({
        ...rowFixtures,
        arrDetails: arrDetails,
      });
    } else {
      let arrDetails = arrRound[jRound].arrDetails;
      arrDetails.push({ ...rowFixtures });
    }
  }
  return arrRound;
};
app.getFixtureByMatchId = (arrFixtures, jId) => {
  let objMatch = null;
  if (jId) {
    loop1: for (let j = 0; j < (arrFixtures || []).length; j++) {
      let objRow = arrFixtures[j];
      if (objRow.MatchId === jId) {
        objMatch = objRow;
        break loop1;
      }
    }
  }
  return objMatch;
};
app.isPointCalDone = (arrFixture) => {
  let isMatchFinished = false;
  for (let j = 0; j < (arrFixture || []).length; j++) {
    let obj = arrFixture[j];
    if (obj) {
      let sMatchStatus = app.getFixtureStatusByRow(obj);
      if (sMatchStatus === config.enumFixtureType.isFinished) {
        isMatchFinished = true;
        break;
      }
    }
  }
  return isMatchFinished;
};

app.getMyFirstFixture = (arrFixture, ftgid) => {
  let obj = null;
  let firstGD = ftgid ? ftgid : 0;

  let myFirstFix = find(arrFixture || [], (f) => {
    return f.TeamGamedayId == firstGD;
  });

  if (myFirstFix) {
    let status = app.getFixtureStatusByRow(myFirstFix);
    obj = {
      fixture: myFirstFix,
      status: status,
    };
  }

  return obj;
};

app.getRecentFixture = (arrFixture, ftgid, liveOnly) => {
  let obj = null;
  let firstGD = ftgid ? ftgid : 0;

  let filteredFixtures = filter(arrFixture || [], (f) => {
    return f.TeamGamedayId >= firstGD;
  });

  if (filteredFixtures && filteredFixtures.length) {
    let openGamedays = find(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return status == config.enumFixtureType.isOpen;
    });
    if (openGamedays && !liveOnly) {
      let status = app.getFixtureStatusByRow(openGamedays);
      obj = {
        fixture: openGamedays,
        status: status,
      };
    }

    let postGamedays = findLast(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return status == config.enumFixtureType.isFinished;
    });
    if (postGamedays && !liveOnly) {
      let status = app.getFixtureStatusByRow(postGamedays);
      obj = {
        fixture: postGamedays,
        status: status,
      };
    }

    let liveGamedays = findLast(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return (
        status == config.enumFixtureType.isLock ||
        status == config.enumFixtureType.isLive ||
        status == config.enumFixtureType.isEnded
      );
    });
    if (liveGamedays) {
      let status = app.getFixtureStatusByRow(liveGamedays);
      obj = {
        fixture: liveGamedays,
        status: status,
      };
    }
  }

  return obj;
};

app.isFoundPlayerFromFilter = (arrFiltresTab, ele, arrFixtures) => {
  let fFound = true;
  let arrFound = [];
  for (let j = 0; j < (arrFiltresTab || []).length; j++) {
    const objRow = arrFiltresTab[j];
    let arrDetails = objRow.arrDetails;
    for (let jN = 0; jN < (arrDetails || []).length; jN++) {
      const objFilter = arrDetails[jN];
      if (objFilter.checked) {
        fFound = false;
        if (objRow.id === config.enumTabsId.teams) {
          if (objFilter.id === ele.TeamId) {
            fFound = true;
            break;
          }
        } else if (objRow.id === config.enumTabsId.matches) {
          const objMatch = app.getMatchDetailsById(arrFixtures, objFilter.id);
          if (objMatch) {
            if (
              objMatch.HomeTeamId === ele.TeamId ||
              objMatch.AwayTeamId === ele.TeamId
            ) {
              fFound = true;
              break;
            }
          }
        } else if (objRow.id === config.enumTabsId.nationality) {
          if (objFilter.id === config.enumNationalityIds.foreign) {
            if (Number(ele.IS_FP)) {
              fFound = true;
              break;
            }
          } else if (objFilter.id === config.enumNationalityIds.indian) {
            if (!Number(ele.IS_FP)) {
              fFound = true;
              break;
            }
          }
        } else if (objRow.id === config.enumTabsId.creditRange) {
          if (
            (objFilter.min === -1 || ele.Value >= objFilter.min) &&
            (objFilter.max === -1 || ele.Value <= objFilter.max)
          ) {
            fFound = true;
            break;
          }
        }
      }
    }
    arrFound.push(fFound);
  }
  for (let j = 0; j < arrFound.length; j++) {
    let row = arrFound[j];
    if (!row) {
      fFound = false;
    }
  }
  return fFound;
};
app.getRenderPlayers = (arrSelectedPlayer) => {
  let objRenderPlayer = {
    [config.enumPosition.wk]: [],
    [config.enumPosition.bat]: [],
    [config.enumPosition.ar]: [],
    [config.enumPosition.bowl]: [],
  };
  for (let j = 0; j < arrSelectedPlayer.length; j++) {
    const objPlayer = arrSelectedPlayer[j];
    const isInSkillRange = config.enumPositionText[objPlayer.SkillId];
    if (isInSkillRange) {
      objRenderPlayer[objPlayer.SkillId].push(objPlayer);
    }
  }
  return objRenderPlayer;
};
app.getPlayerDetails = (arrPlayerListing, Id, arrUserTeamPlayerList) => {
  let arrUserTeamPlayerListT = arrUserTeamPlayerList;
  let arrPlayerListingT = arrPlayerListing;
  if (!arrPlayerListing) {
    arrPlayerListingT = [];
  }
  if (!arrUserTeamPlayerList) {
    arrUserTeamPlayerListT = [];
  }
  const jIndexSelectedPlayer = core.getIndexOfArrayByValue(
    arrPlayerListingT,
    "Id",
    Id
  );
  let objMain = arrPlayerListingT[jIndexSelectedPlayer];
  objMain = objMain ? objMain : {};
  const jIndexTeamPlayer = core.getIndexOfArrayByValue(
    arrUserTeamPlayerListT,
    "id",
    Id
  );
  let objMainTeam = arrUserTeamPlayerListT[jIndexTeamPlayer];
  objMainTeam = objMainTeam ? objMainTeam : {};
  return { ...objMain, ...objMainTeam };
};
app.getSelectedCountBySkill = (arrSelectedPlayerP) => {
  let jWkLength = 0;
  let jBtLength = 0;
  let jBlLength = 0;
  let jArLength = 0;
  let arrSelectedPlayer = arrSelectedPlayerP;
  for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
    let rowPosition = arrSelectedPlayer[j];
    if (rowPosition.Id !== config.emptyValue) {
      if (rowPosition.SkillId === config.enumPosition.wk) {
        jWkLength = jWkLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.bat) {
        jBtLength = jBtLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.bowl) {
        jBlLength = jBlLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.ar) {
        jArLength = jArLength + 1;
      }
    }
  }

  return {
    jWkCount: jWkLength,
    jBtCount: jBtLength,
    jBlCount: jBlLength,
    jArCount: jArLength,
  };
};
app.getMaxMinValidation = (
  arrSelectedPlayer,
  jSkill,
  jSkillMaxLength,
  jMaxTeamCount
) => {
  let objReturn = {};
  let objCountsSkill = app.getSelectedCountBySkill(arrSelectedPlayer);
  let { jWkCount, jBtCount, jBlCount, jArCount } = objCountsSkill;
  let wkMin = config.enumMinPositionNos[config.enumPosition.wk]; //= 1;
  let batMin = config.enumMinPositionNos[config.enumPosition.bat]; // = 3;
  let bowlMin = config.enumMinPositionNos[config.enumPosition.bowl]; // = 3;
  let arMin = config.enumMinPositionNos[config.enumPosition.ar]; // = 2;
  //MAX
  let jCurrentSkillLength = 0;
  for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
    let rowPlayer = arrSelectedPlayer[j];
    if (rowPlayer.SkillId === jSkill) {
      jCurrentSkillLength = jCurrentSkillLength + 1;
    }
  }
  wkMin = wkMin - jWkCount;
  if (jSkill === config.enumPosition.wk) {
    wkMin = wkMin - 1;
  }
  wkMin = wkMin < 0 ? 0 : wkMin;
  batMin = batMin - jBtCount;
  if (jSkill === config.enumPosition.bat) {
    batMin = batMin - 1;
  }
  batMin = batMin < 0 ? 0 : batMin;
  bowlMin = bowlMin - jBlCount;
  if (jSkill === config.enumPosition.bowl) {
    bowlMin = bowlMin - 1;
  }
  bowlMin = bowlMin < 0 ? 0 : bowlMin;
  arMin = arMin - jArCount;
  if (jSkill === config.enumPosition.ar) {
    arMin = arMin - 1;
  }
  arMin = arMin < 0 ? 0 : arMin;
  let jAvailableSkillPlace = wkMin + batMin + bowlMin + arMin;
  objReturn = { wkMin: wkMin, batMin: batMin, bowlMin: bowlMin, arMin: arMin };
  if (jSkillMaxLength <= jCurrentSkillLength) {
    objReturn = { ...objReturn, retVal: config.enumMinMaxType.max };
  }
  //check for minimum positions.
  else if (jMaxTeamCount - 1 < jAvailableSkillPlace) {
    objReturn = { ...objReturn, retVal: config.enumMinMaxType.min };
  }
  return objReturn;
};
app.addInTeamSelection = (
  arrSelectedPlayer,
  jPlayerId,
  jSkill,
  jMaxTeamCountT,
  isCaptain,
  isViceCaptain
) => {
  let flag = false;
  let objCountsSkill = app.getSelectedCountBySkill(arrSelectedPlayer);
  let { jWkCount, jBtCount, jBlCount, jArCount } = objCountsSkill;
  let wkMin = config.enumMinPositionNos[config.enumPosition.wk]; //= 1;
  let batMin = config.enumMinPositionNos[config.enumPosition.bat]; // = 3;
  let bowlMin = config.enumMinPositionNos[config.enumPosition.bowl]; // = 3;
  let arMin = config.enumMinPositionNos[config.enumPosition.ar]; // = 2;
  wkMin = wkMin - jWkCount;
  if (jSkill === config.enumPosition.wk) {
    wkMin = wkMin - 1;
  }
  wkMin = wkMin < 0 ? 0 : wkMin;
  batMin = batMin - jBtCount;
  if (jSkill === config.enumPosition.bat) {
    batMin = batMin - 1;
  }
  batMin = batMin < 0 ? 0 : batMin;
  bowlMin = bowlMin - jBlCount;
  if (jSkill === config.enumPosition.bowl) {
    bowlMin = bowlMin - 1;
  }
  bowlMin = bowlMin < 0 ? 0 : bowlMin;
  arMin = arMin - jArCount;
  if (jSkill === config.enumPosition.ar) {
    arMin = arMin - 1;
  }
  arMin = arMin < 0 ? 0 : arMin;
  let jAvailableSkillPlace = wkMin + batMin + bowlMin + arMin;
  let jAvailableSkillPlaceT = jAvailableSkillPlace;
  if (jSkill === config.enumPosition.wk) {
    jAvailableSkillPlaceT = batMin + bowlMin + arMin;
  } else if (jSkill === config.enumPosition.bat) {
    jAvailableSkillPlaceT = wkMin + bowlMin + arMin;
  } else if (jSkill === config.enumPosition.bowl) {
    jAvailableSkillPlaceT = wkMin + batMin + arMin;
  } else if (jSkill === config.enumPosition.ar) {
    jAvailableSkillPlaceT = wkMin + batMin + bowlMin;
  }
  if (jMaxTeamCountT > jAvailableSkillPlaceT) {
    for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
      let rowPlayer = arrSelectedPlayer[j];
      if (
        rowPlayer.Id === config.emptyValue &&
        rowPlayer.defaultSkillId === jSkill
      ) {
        rowPlayer.Id = jPlayerId;
        rowPlayer.SkillId = jSkill;
        if (isCaptain) {
          rowPlayer.isCaptain = isCaptain;
        } else if (isViceCaptain) {
          rowPlayer.isViceCaptain = isViceCaptain;
        }
        flag = true;
        break;
      }
    }
    if (!flag) {
      for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
        let rowPlayer = arrSelectedPlayer[j];
        if (
          rowPlayer.Id ===
          config.emptyValue /*  && rowPlayer.defaultSkillId === config.enumPosition.ar */
        ) {
          rowPlayer.Id = jPlayerId;
          rowPlayer.SkillId = jSkill;
          if (isCaptain) {
            rowPlayer.isCaptain = isCaptain;
          } else if (isViceCaptain) {
            rowPlayer.isViceCaptain = isViceCaptain;
          }
          flag = true;
          break;
        }
      }
    }
  }
  return {
    flag: flag,
    arrSelectedPlayer: arrSelectedPlayer,
  };
};
app.switchExistingFormation = (
  objPlayer,
  jSkillP,
  arrSelectedPlayer,
  players,
  jMaxTeamCount,
  isIgnore
) => {
  let objReturn = {
    retVal: config.enumSwitchType.none,
  };
  const SecondarySkillId =
    jSkillP === Number(objPlayer.SkillId)
      ? Number(objPlayer.SecondarySkillId)
      : Number(objPlayer.SkillId);
  const jPlayerId = Number(objPlayer.Id);
  let hasSecSkill = config.enumMaxPositionNos[SecondarySkillId];
  let flag = false;
  let jSkill = jSkillP;
  let jSkillMaxLength = config.enumMaxPositionNos[jSkill]
    ? config.enumMaxPositionNos[jSkill]
    : 0;
  let objMaxMinValidation = app.getMaxMinValidation(
    arrSelectedPlayer,
    jSkill,
    jSkillMaxLength,
    jMaxTeamCount
  );
  if (objMaxMinValidation.retVal === config.enumMinMaxType.max) {
  } else if (objMaxMinValidation.retVal === config.enumMinMaxType.min) {
  } else {
    //add
    const objSelectionAdded = app.addInTeamSelection(
      arrSelectedPlayer,
      jPlayerId,
      jSkill,
      jMaxTeamCount
    );
    flag = objSelectionAdded.flag;
    arrSelectedPlayer = objSelectionAdded.arrSelectedPlayer;
    objReturn = {
      retVal: config.enumSwitchType.changeSource,
      arrSelectedPlayer: arrSelectedPlayer,
      flag: flag,
    };
  }

  return objReturn;
};
app.getSkillShortNameBySillId = (arrSkillFiltreTab, SkillId) => {
  let objSkillFiltreTab = null;
  let SkillShortName = "";
  for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
    const rowObj = arrSkillFiltreTab[j];
    if (rowObj.SkillId === SkillId) {
      SkillShortName = rowObj.SkillShortName;
      break;
    }
  }
  return SkillShortName;
};
app.converToCurrencyFormat = (number) => {
  if (number) {
    var integer = Number(number);
    var num = integer.toString();
    var decimalArr = num.split("."); // for decimal
    var numArr = decimalArr[0].split("");
    var count = 0;
    var newArr = [];
    for (var i = numArr.length - 1; i >= 0; i--) {
      newArr.unshift(numArr[i]);
      if (count % 2 == 0 && !(count == 0 || count == numArr.length - 1)) {
        newArr.unshift(",");
      }
      count++;
    }
    return newArr.join("") + (decimalArr[1] ? "." + decimalArr[1] : "");
  }
  return number;
};

app.getFilteredContestPlayer = (arrFiltresTab, players) => {
  let arrFilteredPlayer = [];

  if (players) {
    arrFiltresTab.map((data) => {
      const { arrDetails } = data;
      return arrDetails.map((team) => {
        if (team.tempChecked || team.checked) {
          for (let i = 0; i < players.length; i++) {
            let filterTeamId = team.id;
            let playerTeamId = players[i].teamid;
            if (filterTeamId == playerTeamId) {
              arrFilteredPlayer.push(players[i]);
            }
          }
        }
      });
    });
    arrFilteredPlayer.sort((a, b) => b.ovrpoint - a.ovrpoint);
  }

  return { arrFilteredPlayer: arrFilteredPlayer };
};
app.getFilteredContestPoints = (arrFiltresTab, points) => {
  let arrFilteredPoints = [];

  if (points) {
    arrFiltresTab.map((data) => {
      const { arrDetails } = data;
      return arrDetails.map((team) => {
        if (team.tempChecked || team.checked) {
          for (let i = 0; i < points.length; i++) {
            let filterTeamId = team.id;
            let playerTeamId = points[i].TeamId;
            if (filterTeamId == playerTeamId) {
              arrFilteredPoints.push(points[i]);
            }
          }
        }
      });
    });
    arrFilteredPoints.sort((a, b) => b.OverallPoints - a.OverallPoints);
  }

  return { arrFilteredPoints: arrFilteredPoints };
};

app.isValidValue = (val) => {
  let res = false;
  if (val !== undefined && val !== null && val !== "") {
    res = true;
  }
  return res;
};
app.processLeaderboardData = (oldData, newData) => {
  let mergedData = oldData;
  if (newData && newData.length) {
    mergedData = concat(oldData, newData);
  }
  return mergedData;
};
app.processUserRankDataManipulation = (leagueObj) => {
  const objCookie = app.getLoginCookie();
  let obj = {
    rno: 0,
    temid: leagueObj.temid ? leagueObj.temid : 0,
    // temid: objCookie && objCookie.TeamId ? objCookie.TeamId : 0,
    temname: "",
    usrname: objCookie && objCookie.UserName ? objCookie.UserName : "",
    usrscoid: objCookie && objCookie.SocialId ? objCookie.SocialId : "",
    usrclnid: 1,
    rank: leagueObj.ovrank,
    points: leagueObj.ovpts,
    ftgdid: leagueObj.ftgdid ? leagueObj.ftgdid : 0,
    prfimg: objCookie && objCookie.ProfileURL ? objCookie.ProfileURL : "",
  };
  return obj;
};
app.getTotalPointsOfTeam = (
  arrPlayers,
  arrUserTeam,
  jCaptain,
  jViceCaptain
) => {
  let jTotal = 0;

  for (let j = 0; j < (arrUserTeam || []).length; j++) {
    let jId = arrUserTeam[j];
    let isCaptain = false;
    let isViceCaptain = false;
    const objMain = app.getPlayerDetails(arrPlayers, jId, []);
    if (objMain) {
      if (objMain.Id === jCaptain) {
        isCaptain = true;
      } else if (jViceCaptain === objMain.Id) {
        isViceCaptain = true;
      }
      let jPoints = 0;
      if (objMain.IsAnnounced === "P") {
        jPoints = Number(objMain.GamedayPoints);
        if (isCaptain) {
          jPoints = config.enumBonus.captain * Number(objMain.GamedayPoints);
        } else if (isViceCaptain) {
          jPoints =
            config.enumBonus.viceCaptain * Number(objMain.GamedayPoints);
        }
        jTotal = jTotal + jPoints;
      }
    }
  }
  jTotal = Number(jTotal).toFixed(1);
  jTotal = jTotal ? Number(jTotal) : jTotal;
  return { jTotal };
};

app.getMatchdays = (arrRound, hasTeam, isFreez, renderType, TeamGamedayId) => {
  let cookie = app.getLoginCookie();
  let jFixture = -1;
  let arrFilteredFixure = [];
  let fBreak = false;
  let fIsPointCalculationDone = app.isPointCalDone(arrRound);
  let isLockedAny = false;

  for (let jN = 0; jN < (arrRound || []).length; jN++) {
    let row = arrRound[jN];
    let rowFixture = row;
    let isIndexOfMatchdayId =
      hasTeam && hasTeam <= Number(rowFixture.TeamGamedayId);
    let jStatus = app.getFixtureStatusByRow(rowFixture);
    if (cookie && isIndexOfMatchdayId) {
      if (
        fIsPointCalculationDone &&
        (renderType === config.enumTeamRenderType.contest ||
          renderType === config.enumTeamRenderType.leaderboard)
      ) {
        if (jStatus !== config.enumFixtureType.isUpcomming) {
          arrFilteredFixure.push({ ...rowFixture });
          fBreak = true;
          jFixture = arrFilteredFixure.length - 1;
        }
      } else if (jStatus !== config.enumFixtureType.isUpcomming) {
        arrFilteredFixure.push({ ...rowFixture });
        fBreak = true;
        jFixture = arrFilteredFixure.length - 1;
      }

      if (
        jStatus !== config.enumFixtureType.isUpcomming &&
        jStatus !== config.enumFixtureType.isOpen
      ) {
        isLockedAny = true;
      }
    }
  }
  if (
    renderType === config.enumTeamRenderType.contest ||
    renderType === config.enumTeamRenderType.leaderboard
  ) {
    if (isLockedAny) {
      let arrRoundT = [];
      for (let j = 0; j < (arrFilteredFixure || []).length; j++) {
        const objRow = arrFilteredFixure[j];
        let jStatus = app.getFixtureStatusByRow(objRow);
        if (jStatus !== config.enumFixtureType.isOpen) {
          arrRoundT.push({ ...objRow });
          jFixture = arrRoundT.length - 1;
        }
      }
      arrFilteredFixure = arrRoundT;
      if (renderType === config.enumTeamRenderType.leaderboard) {
        arrFilteredFixure.push({ isOverall: true });
      }
    }
  }

  if (TeamGamedayId) {
    for (let j = 0; j < arrFilteredFixure.length; j++) {
      let row = arrFilteredFixure[j];
      if (TeamGamedayId === +row.TeamGamedayId) {
        jFixture = j;
        break;
      }
    }
  }
  if (jFixture === -1) {
    for (let j = 0; j < arrFilteredFixure.length; j++) {
      let row = arrFilteredFixure[j];
      let jStatus = app.getFixtureStatusByRow(row);
      // if (jStatus === config.enumFixtureType.isFinished || jStatus === config.enumFixtureType.isLock || jStatus === config.enumFixtureType.isEnded || jStatus === config.enumFixtureType.isAbandoned || jStatus === config.enumFixtureType.isOpen) {
      if (jStatus !== config.enumFixtureType.isUpcomming) {
        jFixture = j;
        // jGameDayId = row.GamedayId;
        // jPhaseId = row.PhaseId;
        //break;
      }
    }
  }

  return { arrFilteredFixure: arrFilteredFixure, jFixture: jFixture };
};
app.isFixtureChanged = (
  arrFixtures,
  LiveFixture,
  AbandonedGameDayId,
  FreezeGamedayId,
  VersionMaster,
  objMixOld
) => {
  let isSame = true;
  for (let j = 0; j < arrFixtures.length; j++) {
    const objRow = arrFixtures[j];
    const jMdStatus = app.getFixtureStatusByRow(objRow);
    if (LiveFixture && LiveFixture.length) {
      for (let jN = 0; jN < LiveFixture.length; jN++) {
        const objRowLive = LiveFixture[jN];
        const jMdStatusLive = app.getFixtureStatusByRow(objRowLive);
        if (
          jMdStatus !== jMdStatusLive &&
          objRow.TeamGamedayId === objRowLive.TeamGamedayId
        ) {
          isSame = false;
          break;
        }
      }
    }
  }
  if (isSame) {
    let oldLiveFixture = null;
    let VersionMasterOld = -1;
    if (objMixOld) {
      oldLiveFixture = objMixOld.LiveFixture;
      VersionMasterOld = objMixOld.VersionMaster;
    }
    if (
      (VersionMasterOld !== -1 && VersionMaster !== VersionMasterOld) ||
      (oldLiveFixture &&
        oldLiveFixture.length &&
        !(LiveFixture && LiveFixture.length))
    ) {
      isSame = false;
    }
  }
  return isSame;
};

app.setErrorCode = (jStatusCode) => {
  let jErrorcode = config.enumErrorCode.normal;
  const arrToast = [403, 401, -999];
  const arrRedirect = [500, 400];
  if (arrToast.indexOf(jStatusCode) > -1) {
    jErrorcode = config.enumErrorCode.isToast;
  } else if (arrRedirect.indexOf(jStatusCode) > -1) {
    jErrorcode = config.enumErrorCode.isRedirect;
  }
  return jErrorcode;
};
app.getUTMParameters = (sUrl) => {
  const objUrl = core.getQueryParams(sUrl ? sUrl : window.location.href);
  let search = "";
  for (let sKey in objUrl) {
    if (sKey.indexOf("utm_") > -1) {
      const sValue = objUrl[sKey];
      if (sValue && sValue !== "undefined") {
        if (!search) {
          search = "?";
        } else {
          search = `${search}&`;
        }
        search = `${search}${sKey}=${sValue}`;
      }
    }
  }
  return search;
};
app.getBulletsClass = (
  jIndex,
  jActiveIndex,
  jMdStatus,
  isAttempted,
  isResolved,
  isCorrect,
  status,
  isJokerApplied
) => {
  let jBulletId = config.enumBulletsClassType.isEmpty;
  let sPostFixClass = "";
  let sPostFixClassIcon = "";
  if (status === config.enumQuestionStatus.open) {
    if (isAttempted) {
      jBulletId = config.enumBulletsClassType.isAnswered;
    }
    if (isAttempted && isJokerApplied) {
      jBulletId = config.enumBulletsClassType.isJokerApplied;
    }
    /* if (jIndex === jActiveIndex) {
      sPostFixClass = 'si-active si-circle';
      sPostFixClassIcon = '';
    } */
  } else {
    jBulletId = config.enumBulletsClassType.isEmptyLocked;
    if (isAttempted) {
      jBulletId = config.enumBulletsClassType.isAnsweredLocked;
      if (isResolved) {
        if (isCorrect) {
          jBulletId = config.enumBulletsClassType.isCorrect;
        } else {
          jBulletId = config.enumBulletsClassType.isWrong;
        }
      }
    }
    /* if (jIndex === jActiveIndex) {
      sPostFixClass = 'si-circle';
      sPostFixClassIcon = '';
    } */
  }
  if (config.IS_BET) {
    if (status !== config.enumQuestionStatus.open) {
      jBulletId = config.enumBulletsClassType.isEmptyLocked;
    }
    if (isAttempted) {
      if (isAttempted.isTemp) {
        jBulletId = config.enumBulletsClassType.isAnswered;
      } else {
        jBulletId = config.enumBulletsClassType.isAnsweredLocked;
        if (isResolved) {
          if (isCorrect) {
            jBulletId = config.enumBulletsClassType.isCorrect;
          } else {
            jBulletId = config.enumBulletsClassType.isWrong;
          }
        }
      }
    }
  }
  if (jIndex === jActiveIndex) {
    sPostFixClass = "si-active";
    sPostFixClassIcon = "";
  }

  return {
    jBulletId,
    sPostFixClass,
    sPostFixClassIcon,
  };
};
app.getSelected = (arrList, jIndex) => {
  const objSelected = arrList && arrList.length && arrList[jIndex];
  return objSelected;
};

// isAllQuestionAttempted
app.isAllQuestionAttempted = (arrAnswers, arrQuestions) => {
  let s = 0;
  let sum = [];
  arrQuestions &&
    arrQuestions.forEach((element) => {
      arrAnswers &&
        arrAnswers.forEach((el) => {
          if (Number(el.questionId) === Number(element.questionId)) {
            sum.push(1);
          }
        });
    });
  if (sum && sum.length == 6) return 1;
  else return 0;
};
// isAllQuestionAttempted

// isJokerUsed
app.isJokerUsedOnQuest = (objUsersAnswers, arrQuestions) => {
  let boosterQuestionId = objUsersAnswers?.boosterquesId;
  let arrQuestionsID = arrQuestions?.filter((obj) => {
    return obj?.questionId === boosterQuestionId;
  });
  let isJokerAppliedTrue = arrQuestionsID[0]?.questionId ? 1 : 0;
  return isJokerAppliedTrue;
};
// isJokerUSed

app.isAttemptByQuestion = (arrAnswers, jQuestionId) => {
  return (
    arrAnswers &&
    arrAnswers.find((ele) => {
      return Number(ele.questionId) === jQuestionId;
    })
  );
};

app.isAttemptByQuestionAndOptions = (arrAnswers, jQuestionId, jOptionId) => {
  return (
    arrAnswers &&
    arrAnswers.find((ele) => {
      return (
        Number(ele.questionId) === jQuestionId &&
        Number(ele.optionId) === jOptionId
      );
    })
  );
};
app.isAttemptByQuestion = (arrAnswers, jQuestionId) => {
  return (
    arrAnswers &&
    arrAnswers.find((ele) => {
      return Number(ele.questionId) === jQuestionId;
    })
  );
};

// app.sortArrOptions
app.sortArrOptions = (arrAnswers, questionId, arrOptions) => {
  let returnArr = [];
  let questAttempted = arrAnswers?.find(
    (obj) => obj == null || questionId === obj.questionId
  );
  // if (!questAttempted?.optionId) return arrOptions;
  // not selected questtions
  if (!questAttempted?.optionId) {
    arrOptions.forEach((obj) => {
      obj.isCorrect === 1 ? returnArr.unshift(obj) : returnArr.push(obj);
    });
    return returnArr;
  }

  let selectedOptions = arrOptions?.find(
    (obj) => questAttempted.optionId === obj?.optionId
  );

  let correctAnswer = arrOptions?.filter(
    (obj) => obj.isCorrect === 1 && obj.optionId !== selectedOptions.optionId
  );

  const notSelectedOptions = arrOptions.filter(
    (obj) => questAttempted.optionId !== obj.optionId && obj.isCorrect !== 1
  );

  returnArr = [selectedOptions, ...correctAnswer, ...notSelectedOptions];
  return returnArr;
};

app.getBetCoinsForOption = (arrAnswers, jQuestionId, jOptionId) => {
  let answer =
    arrAnswers &&
    arrAnswers.find((ele) => {
      return (
        Number(ele.questionId) === jQuestionId &&
        Number(ele.optionId) === jOptionId
      );
    });
  return answer.coinBet;
};

app.getSelectedOptionFromArrAnswers = (arrAnswers, jQuestionId, arrOptions) => {
  let answer =
    arrAnswers &&
    arrAnswers.find((ele) => {
      return Number(jQuestionId) === Number(ele.questionId);
    });
  if (answer) {
    let option =
      arrOptions &&
      arrOptions.find((ele) => {
        return Number(ele.optionId) === Number(answer.optionId);
      });
    return { selectedOption: option, selectedAnswer: answer };
  } else {
    return;
  }
};
app.getNextActiveIndex = (
  arrAnswers,
  arrQuestions,
  jActiveIndex,
  isInitialCall,
  jMatchStatus
) => {
  let jNextIndexT =
    arrQuestions &&
    arrQuestions.findIndex((ele, jIndex) => {
      const { questionId, status } = ele;
      const isOpen = status === config.enumQuestionStatus.open;
      let isValid = false;
      if (isOpen) {
        if (isInitialCall) {
          isValid = true;
        } else if (jActiveIndex < jIndex) {
          isValid = true;
        } else {
          return null;
        }

        if (isValid) {
          const jQuestionId = Number(questionId);
          const obj =
            arrAnswers &&
            arrAnswers.find((eleA) => {
              return Number(eleA.questionId) === jQuestionId;
            });
          return !obj;
        }
      }
    });
  if (jNextIndexT > -1 || jActiveIndex !== -1) {
    return jNextIndexT;
  } else if (config.enumMatchStatus.live.indexOf(jMatchStatus) > -1) {
    return arrQuestions.length - 1;
  } else {
    return jActiveIndex;
  }
};
app.getPointsDetails = (MatchId, objUserPoints) => {
  let obj = null;
  if (objUserPoints) {
    for (let jN = 0; jN < (objUserPoints.rankdetail || []).length; jN++) {
      const objRank = objUserPoints.rankdetail[jN];
      if (objRank) {
        const { matchId, rank, points } = objRank;
        if (matchId === MatchId) {
          obj = objRank;
          break;
        }
      }
    }
  }
  return obj;
};
app.pointsBySelectedPercent = (
  selectedPercent,
  objPointsConstraints,
  isCorrect,
  jBoosterId,
  isResolved,
  isAttempted
) => {
  const {
    basePoints,
    arrDetails: arrPointsConstraints,
    booster1,
    booster2,
  } = objPointsConstraints || {};
  let jPoints = 0;
  let jPointsWithoutBooster = 0;
  if (isResolved && isAttempted) {
    jPoints = basePoints;
    for (let j = 0; j < (arrPointsConstraints || []).length; j++) {
      let objRow = arrPointsConstraints[j];
      if (
        objRow.min <= selectedPercent &&
        (objRow.max >= selectedPercent || objRow.max === -1)
      ) {
        jPoints = isCorrect ? jPoints + objRow.plusPoints : objRow.minusPoints;
        break;
      }
    }
    jPointsWithoutBooster = jPoints;
    if (jBoosterId === config.enumBoosters.booster1) {
      jPoints = jPoints * booster1;
    } else if (jBoosterId === config.enumBoosters.booster2) {
      jPoints = jPoints * booster2;
    }
  }
  let sPoints = "";
  let sPointsWithoutBooster = "";
  if (jPoints || (isResolved && jPoints === 0)) {
    if (jPoints >= 0) {
      if (jPoints === 0) {
        sPoints = `${jPoints}`;
        sPointsWithoutBooster = `${jPointsWithoutBooster}`;
      } else {
        sPoints = `+${jPoints}`;
        sPointsWithoutBooster = `+${jPointsWithoutBooster}`;
      }
    } else {
      sPoints = `${jPoints}`;
      sPointsWithoutBooster = `${jPointsWithoutBooster}`;
    }
  }
  return {
    jPoints,
    sPoints: sPoints,
    jPointsWithoutBooster,
    sPointsWithoutBooster,
  };
};
app.calTotolPoints = (
  jMdStatus,
  arrQuestions,
  arrAnswers,
  objPointsConstraints,
  jBooster1,
  jBooster2
) => {
  let jTotalPoints = 0;
  loop1: for (let j = 0; j < (arrQuestions || []).length; j++) {
    const objQuestion = arrQuestions[j];
    const { questionId, status, options } = objQuestion;
    const jQuestionId = Number(questionId);
    const jBoosterId = app.setBoosterId(jBooster1, jBooster2, jQuestionId);
    const isAttempted = app.isAttemptByQuestion(arrAnswers, jQuestionId);
    const isResolved = status === config.enumQuestionStatus.resolved;
    const objCorrect =
      options &&
      options.find((ele) => {
        return ele.isCorrect;
      });
    const isCorrect = objCorrect ? 1 : 0;
    if (config.enumMatchStatus.upcomingLive.indexOf(jMdStatus) === -1) {
      let selectedPercent = 0;
      if (objCorrect) {
        selectedPercent = objCorrect.selectedPercent;
      }
      const objPoints = app.pointsBySelectedPercent(
        selectedPercent,
        objPointsConstraints,
        isCorrect,
        jBoosterId
      );
      const { sPoints, jPoints } = objPoints;
      jTotalPoints = jTotalPoints + jPoints;
    }
  }
  return jTotalPoints;
};
app.setBoosterId = (jBooster1, jBooster2, jQuestionId) => {
  let jBoosterId = 0;
  if (jBooster1 === jQuestionId) {
    jBoosterId = config.enumBoosters.booster1;
  } else if (jBooster2 === jQuestionId) {
    jBoosterId = config.enumBoosters.booster2;
  }
  return jBoosterId;
};

// app.getVersionFromMix starts here
app.getVersionFromMix = (objMix, nm, matchId) => {
  let vn = "0";
  if (objMix) {
    const { api: arrAPI, ov, lb: arrLeadeerboardAPI } = objMix;
    switch (nm) {
      case config.enumMixAPI.leaderboard: {
        if (arrLeadeerboardAPI && arrLeadeerboardAPI.length) {
          let obj = arrLeadeerboardAPI.find((ele) => {
            return ele.matchId === matchId;
          });
          if (obj && obj.vn) {
            vn = obj.vn;
          }
        }
        break;
      }
      default: {
        if (arrAPI && arrAPI.length) {
          let obj = arrAPI.find((ele) => {
            return ele.nm === nm;
          });
          if (obj && obj.vn) {
            vn = obj.vn;
          }
        }
      }
    }
  }
  return vn;
};
// app.getVersionFromMix ends here

app.getMatchesForLeaderboard = (arrFixtures, objUserPlayedGameDays) => {
  let arrFixture = [];
  if (arrFixtures) {
    arrFixtures.forEach((ele) => {
      const jMdStatus = Number(ele.MatchStatus);
      if (
        config.enumMatchStatus.result.indexOf(jMdStatus) >
        -1 /* && (objUserPlayedGameDays && objUserPlayedGameDays[ele.MatchId]) */
      ) {
        // const sDate = core.dateFormat(ele.MatchDate, 'dd mmm');
        const sDate = `${ele.TeamAShortName} vs ${ele.TeamBShortName}`;
        arrFixture.push({ ...ele, id: ele.MatchId, name: sDate });
      }
    });
    arrFixture.reverse();
  }
  return arrFixture;
};

app.getLoginStatus = () => {
  const sParentCookie = core.getCookie(config.parentCookie);
  let parentCookie = null;
  if (sParentCookie) {
    parentCookie = JSON.parse(sParentCookie);
  }
  let cookie = app.getLoginCookie();
  let status = config.enumCookieStatus.none;

  if (parentCookie && cookie) {
    status = config.enumCookieStatus.both;
    // if mismatch the condition guid basis code if requires ...
    // if (parentCookie.user_guid !== cookie.WAF_GUID) {
    //   status = config.enumCookieStatus.missMatch;
    // }
  } else if (parentCookie) {
    status = config.enumCookieStatus.onlyParent;
  } else if (cookie) {
    status = config.enumCookieStatus.onlyChild;
  }
  return {
    status,
    cookie,
    parentCookie,
  };
};

app.scrollTop = () => {
  const $nodeParent = document.querySelector(".si-predictor");
  if ($nodeParent) {
    core.smoothScroll($nodeParent);
  }
};

app.validateForFocus = (arrQuestionsOld, arrQuestionsNew) => {
  let isValid = false;
  let jResolved = 0;
  let jResolvedOld = 0;
  let jOpen = 0;
  let jOpenOld = 0;
  let arrOpen = [];
  let arrOpenOld = [];
  //Old
  arrQuestionsOld &&
    arrQuestionsOld.forEach((objQuestion) => {
      const { questionId, status, options } = objQuestion;
      const isResolved = status === config.enumQuestionStatus.resolved;
      const isOpen = status === config.enumQuestionStatus.open;
      if (isResolved) {
        jResolvedOld = jResolvedOld + 1;
      }
      if (isOpen) {
        arrOpenOld.push(Number(questionId));
        jOpenOld = jOpenOld + 1;
      }
    });
  //New
  arrQuestionsNew &&
    arrQuestionsNew.forEach((objQuestion) => {
      const { questionId, status, options } = objQuestion;
      const isResolved = status === config.enumQuestionStatus.resolved;
      const isOpen = status === config.enumQuestionStatus.open;
      if (isResolved) {
        jResolved = jResolved + 1;
      }
      if (isOpen) {
        arrOpen.push(Number(questionId));
        jOpen = jOpen + 1;
      }
    });
  let isNew = false;
  arrOpen.forEach((ele) => {
    if (arrOpenOld.indexOf(ele) === -1) {
      isNew = true;
    }
  });
  if (jResolvedOld !== jResolved) {
    isValid = false;
  }
  if (jOpenOld !== jOpen || isNew) {
    isValid = true;
  }
  return isValid;
};

app.callMixAPI = (callback) => {
  let obj = {
    url: config.ACCOUNTS_API_BASE_S3 + `mixapi/mix_${config.tourId}.json`,
    method: "get",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.getMatchesLeaderboardMapping = (buster, callback) => {
  let obj = {
    url: config.LEADERBOARD_API_BASE + "mapping" + `/matches_${config.tourId}.json`,
    method: "get",
    params: {
      buster: buster,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.getUserRankLeaderboard = (type, gamedayId, guid, buster, callback) => {
  let obj = {
    url:
      // config.LEADERBOARD_API_BASE +
      config.ACCOUNTS_API_BASE + `Leaderboard/user/${guid}/userrank`,
    // `user/${guid}/` +
    // (type === config.enumLeaderboardType.overall ? type : "gameday") +
    // "rank",
    method: "get",
    params: {
      gamedayId: gamedayId,
      buster: buster,
      phaseId: 1,
      optType: type === "overall" ? 1 : 2,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.getLeaderboardRanks = (type, gamedayId, buster, callback) => {
  if (type === "overall" || (type === "gameday" && gamedayId !== undefined)) {
    let obj = {
      url:
        config.LEADERBOARD_API_BASE +
        type +
        `/leaderboard${
          type === "gameday" && gamedayId !== undefined ? "_" + gamedayId : ""
        }_${config.tourId}.json`,
      method: "get",
      params: {
        // weekId: weekId,
        buster: buster,
      },
    };
    return core
      .makeAPICall(obj)
      .then(function (response) {
        if (callback) {
          callback(response.data);
        }
      })
      .catch(function (error) {
        if (callback) {
          callback(false);
        }
      });
  } else {
    return callback(false);
  }
};

app.getQueryParamsObject = new Proxy(
  new URLSearchParams(window.location.search),
  {
    get: (searchParams, prop) => searchParams.get(prop),
  }
);

app.moEngageEvent = (obj) => {
  window.dataLayer.push(obj);
};

app.platformName = () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let isWebview = params.webview;
  let platform_ID = params.platform_type;
  if (isWebview) {
    if (platform_ID == 2) return "androids";
    if (platform_ID == 3) return "ios";
  }
  return "web";
};

app.handleNetworkStatus = (isOnline, callback) => {
  const stateUpdate = {
    isOnline: isOnline,
    showToast: true,
  };

  if (isOnline) {
    setTimeout(() => {
      if (callback) {
        callback({ showToast: false });
      }
    }, 3000); // Hide toast after 3 seconds when online
  }

  if (callback) {
    callback(stateUpdate);
  }
};


app.onLogin = () => {
  const queryParams = app.getQueryParamsObject;
  const isWebview = queryParams.webview;
  const platform_ID = queryParams.platform_type;
  if (isWebview && platform_ID == 2) {
    try {
      let mobileApp = window.mobileApp || {};
      mobileApp.nativeLogin();
    } catch (error) {
      console.log("Android Error Msg :", error);
    }
  } else if (isWebview && platform_ID == 3) {
    try {
      // let webkit = webkit || {};
      // window.webkit.messageHandlers.nativeLogin.postMessage({
      //   login_type: "iOS",
      // });
      window.webkit.messageHandlers.nativeLogin.postMessage("IOS");
    } catch (error) {
      console.log("IOS Error Msg :", error);
    }
  } else {
    window.location.href = "/login?cbkurl=/games/predictor/home";
  }
  const { action, category, label } = config.enumEventPage.loginClicked;
  app.googleAnalyticsEventTracking(action, category, label);
};

export default app;
